import React from 'react'
import AssetDetailsTab from '../components/table/AssetDetailsTab'
import TabWithDropdown from '../../layout/TabWithDropdown'
import { ASSET_ACTIVITY_STATUS_TYPES_DIC } from '../constants/assetActivitiesStatus'

const ShowAssetView = ({ details, defaultDetails }) => {
  const activity = defaultDetails

  const renderStatus = () => {
    switch (activity?.status) {
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.RECEIVED:
        return <span className="order-status received-style">RECIBIDO</span>
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.SENT:
        return <span className="order-status sent-style">ENVIADO</span>
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.CANCELLED:
        return <span className="order-status cancelled-style">CANCELADO</span>
      default:
        return <span className="order-status received-style">RECIBIDO</span>
    }
  }

  const renderTabs = () => {
    switch (activity?.status) {
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.RECEIVED:
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.SENT:
      case ASSET_ACTIVITY_STATUS_TYPES_DIC.CANCELLED:
        return (
          <ul className="nav nav-tabs">
            <TabWithDropdown
              name="Reporte de activos"
              activeTab={"Reporte de activos"}
              items={[]}
            />
          </ul>
        )
      default:
        return null
    }
  }

  return (
    <>
      <div className="main-show-header">
          <h2>Reporte de activos: {activity?.uid}</h2>
        </div>
        <div className="index-table">
          <div className="show-area">
            <div>
              <div className="status-orders">
                <b className="order-status-b">Estado:</b>
                {renderStatus()}
              </div>

              <div>
                <div>{renderTabs()}</div>

                <div>
                  {activity && (
                    <AssetDetailsTab
                      activity={activity}
                      transactionUuid={activity.uid}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default ShowAssetView
